<template>
    <div>
        <b-col cols="12" class="d-flex justify-content-end">
            <b-button id="add-item-btn" variant="pink-button" v-b-tooltip.hover :title="$addLabel()"
                @click="showItem()">
                <img src="@/assets/images/icon/gradient-add.svg" />
            </b-button>
        </b-col>

        <b-overlay :show="loading" rounded="sm">
            <b-modal no-close-on-backdrop v-model="itemModalShow" id="item-modal" header-class="p-0"
                footer-class="d-flex justify-content-center border-0" @close="itemModalShow = false"
                content-class="primary-items custom-model-wrap" @ok="saveTemplateItem">
                <template #modal-title="{ cancel }">
                    <div class="title-block text-center p-2">
                        {{
                            `${model.id || model.index
                                ? $translate('edit')
                                : $translate('add')
                            } ${$translate('item')}`
                        }}
                    </div>
                    <div class="close-btn" @click="cancel()">x</div>
                </template>
                <!-- <b-overlay :show="loading" rounded="sm"> -->
                <b-form bg-variant="light">
                    <b-form-row>

                        <b-col cols="12" class="mt-2 dd">
                            <label class="mb-1" for="input-ams_integration_type-rpat"><strong>{{
                                $translate('ams_integration_type')
                                    }}</strong><span class="red">*</span></label>
                            <b-form-select class="form-control" id="input-ams_integration_type-rpat"
                                v-model="model.ams_integration_code" :options="ams_integration_codes">
                                <template #first>
                                    <b-form-select-option :value="null">{{ $translate("select_ams_integration_type")
                                        }}</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>

                        <b-col cols="12" class="mt-2">
                            <label class="mb-1" for="input-master_item_id-rpat"><strong>{{
                                $translate('master_item_id')
                                    }}</strong><span class="red">*</span></label>
                            <master-item-type-ahead v-model="model.master_item_id"></master-item-type-ahead>
                        </b-col>


                        <b-col cols="12" class="mt-2">
                            <label class="mb-1" for="input-ai_interface_label-rpat"><strong>{{
                                $translate('ai_interface_label')
                                    }}</strong><span class="red">*</span></label>
                            <b-form-input class="form-control" id="input-ai_interface_label-rpat"
                                v-model="model.ai_interface_label" :placeholder="$translate('ai_interface_label')">
                            </b-form-input>
                        </b-col>



                        <b-col cols="12" class="mt-2">
                            <label class="mb-1" for="input-default_account_allocation_percent-rpat"><strong>{{
                                $translate('default_account_allocation_percent')
                                    }}</strong><span class="red">*</span></label>
                            <b-form-input class="form-control" id="input-default_account_allocation_percent-rpat"
                                v-model="model.default_account_allocation_percent"
                                :placeholder="$translate('default_account_allocation_percent')" type="number" :min="0"
                                :max="100">
                            </b-form-input>
                        </b-col>

                        <b-col cols="12" class="mt-2">
                            <label class="mb-1" for="input-gl_integration_code-rpat"><strong>{{
                                $translate('gl_integration_code')
                                    }}</strong><span class="red">*</span></label>
                            <b-form-input class="form-control" id="input-gl_integration_code-rpat"
                                v-model="model.gl_integration_code" :placeholder="$translate('gl_integration_code')">
                            </b-form-input>
                        </b-col>


                        <b-col cols="12" class="mt-2">
                            <label class="mb-1" for="input-gl_integration_description-rpat"><strong>{{
                                $translate('gl_integration_description')
                                    }}</strong><span class="red">*</span></label>
                            <b-form-input class="form-control" id="input-gl_integration_description-rpat"
                                v-model="model.gl_integration_description"
                                :placeholder="$translate('gl_integration_description')">
                            </b-form-input>
                        </b-col>
                    </b-form-row>
                </b-form>
                <template #modal-footer="{ ok, close }">
                    <b-button id="create-update-item-btn" variant="info" class="btn btn-info btn-fw me-2" @click="ok()">
                        {{
                            `${!!model.index || !!model.id
                                ? $updateLabel()
                                : $createLabel()
                            } ${$translate('item')}`
                        }}
                    </b-button>
                    <b-button id="delete-item-btn" v-if="hasPermissionDelete && (model.id || model.index)" class="me-2"
                        size="fw" variant="delete-button" @click="deleteTemplateItem(model.id)">
                        {{ $deleteLabel() }}
                    </b-button>
                    <b-button id="close-item-btn" variant="info" class="btn-fw" @click="close()">
                        {{ $cancelLabel() }}
                    </b-button>
                </template>

                <!-- </b-overlay> -->
            </b-modal>
        </b-overlay>
        <div class="table-responsive mt-2">
            <b-table class="table table-striped" :fields="fields" :items="templateItems">
                <template #cell(id)="{ item }">
                    <b-button :id="'view-rpa-template-items-btn' + item.id" class="test-view-rpa-template-items-btn"
                        @click="showItem(item.id)" variant="pink-button">
                        <img src="@/assets/images/icon/view.svg" />
                    </b-button>
                </template>
            </b-table>
        </div>
    </div>
</template>
<script>
import permissionsMixins from '@/mixins/permissionsMixins'
import popupMixins from '@/mixins/popupMixins'
import MasterItemTypeAhead from "@/components/MasterItemTypeAhead";
import { capitalCase } from 'change-case'

const MODEL_FIELDS = [
    "id",
    "master_item_id",
    "ai_interface_label",
    "ams_integration_code",
    "default_account_allocation_percent",
    "gl_integration_code",
    "gl_integration_description"
];
export default {
    name: 'rpaTemplates-templateitems',
    props: ['tabIdx'],
    mixins: [permissionsMixins, popupMixins],
    components: {
        MasterItemTypeAhead,
    },
    data() {
        return {
            loading: false,
            itemModalShow: false,
            masterItemFields: [],
            modelChanged: false,
            model: {
                master_item_id: null,
                ai_interface_label: null,
                ams_integration_code: null,
                default_account_allocation_percent: null,
                gl_integration_code: null,
                gl_integration_description: null
            }
        }
    },
    computed: {
        templateItems() {
            return this.$store.state.rpaTemplate.templateItems
        },


        user_permissions() {
            return this.$store.getters.user_permissions
        },

        template() {
            return this.$store.state.rpaTemplate.template
        },
        ams_integration_codes() {
            return this.$store.getters['rpaTemplate/ams_integration_codes']
        },

        fields() {
            return [
                {
                    key: 'id',
                    label: '',
                },
                {
                    key: "ams_integration_code",
                    label: 'AMS Code',
                },

                {
                    key: "ai_interface_label",
                    label: 'AI Label',
                },
                {
                    key: 'master_item',
                    label: this.$translate('master_item'),
                    formatter: value =>
                        value?.name ?? "---",
                },
                {
                    key: "default_account_allocation_percent",
                    label: 'Allocation %',
                },

                {
                    key: "gl_integration_code",
                    label: "GL Code",
                },

                /*    {
                       key: "gl_integration_description",
                       label: 'GL Description',
                   }, */

            ]
        }
    },
    watch: {

    },

    mounted() {
        this.$store.dispatch("itemType/fetchAll");
        this.$store.dispatch("rpaTemplate/fetchItems");
        console.log('masterItems', this.masterItems)
    },
    methods: {
        showItem(id) {
            console.log("id", id)
            let item = null;
            if (id) {
                item = this.templateItems.find(x => x.id == id);
            }
            for (const key of MODEL_FIELDS) {
                let value = null;
                if (id) {
                    value = item[key];
                }
                this.$set(this.model, key, value);
            }
            this.itemModalShow = true
        },
        async deleteTemplateItem() {
            const NOT_CONFIRMED = "Not Confirmed";
            try {
                // Initializing key variables
                console.log('Attempt to delete')
                const model = { ...this.model }
                const path = 'rpaTemplate/deleteItem'

                // Generate and display confirmation prompt
                const title = this.$translate('delete_rpa_template')
                const message = `${this.$translate('delete_note')}`
                const result = await this.confirmMessage(title, message)
                if (!result) throw NOT_CONFIRMED;
                this.loading = true;

                await this.$store.dispatch(path, model.id)
                this.itemModalShow = false;
            } catch (error) {
                if (error !== NOT_CONFIRMED) {
                    console.error(error)
                    this.loading = false;
                    this.doToast(this.$translate('error'), error.message, 'danger')
                }
            } finally {
                this.loading = false;
            }
        },
        async saveTemplateItem(bvModalEvent) {
            bvModalEvent.preventDefault()
            console.log("model:", this.model)
            const NOT_VALIDATED = "Not Validated!";

            try {
                this.loading = true
                const model = { ...this.model }
                console.log('model', model)
                const action = model.id ? 'updateItem' : 'createItem'
                const message = model.id ? this.$translate('update_alert') : this.$translate('create_alert')
                const path = `rpaTemplate/${action}`
                const valid = await this.$validator.validate()
                if (!valid) throw NOT_VALIDATED;
                if (model.ams_integration_code == 'line_item' && !model.master_item_id) {
                    throw new Error("A line item requires a master Item!")
                }
                await this.$store.dispatch(path, model)
                this.itemModalShow = false;
                this.$emit('success', action, message)
            } catch (error) {
                if (error !== NOT_VALIDATED) {
                    console.log('error', error)
                    this.doToast(this.$translate('error'), error.message, 'danger')
                }
            } finally {
                this.loading = false
            }
        }
    },
}
</script>